import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface ISiteLogEntry {
    id: string;
    siteID: string;
    text: string;
    created: Date;
    createdByUserID: string;
    lastUpdated: Date;
    lastUpdatedByUserID: string;
    deleted: Date;
    deletedByUserID: string;
}

export class SiteLogEntry implements ISiteLogEntry {

    constructor(data?: ISiteLogEntry) {
        if (data) this.update(data);
    }

    update(data: ISiteLogEntry): SiteLogEntry {
        mapData(data, { root: () => this });
        return this;
    }

    id: string = Utils.emptyGuidValue;
    siteID: string = Utils.emptyGuidValue;
    text: string = "";
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: string = Utils.emptyGuidValue;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: string = Utils.emptyGuidValue;
    deleted: Date = new Date(Utils.emptyDateValue);
    deletedByUserID: string = Utils.emptyGuidValue;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }
}


